module.exports = __webpack_public_path__ + "img/shebaoka.e58eaf29.png";